export default __webpack_public_path__ + "d92ffdf296a816acd6c5d63538760da2.png";